<template>
  <div
    class="my-signature"
    v-loading="isLoading"
  >
    <!-- Editor -->
    <MySignatureEditor
      v-if="!signatureImageUrl && isEditable"
      :signature="signature"
      :signatureImageUrl="signatureImageUrl"
      :isEditable="isEditable"
      @onClose="$listeners['onClose']"
      @onSubmit="$listeners['onSubmit']"
    />

    <!-- Viewer -->
    <MySignatureViewer
      v-if="signatureImageUrl"
      :signature="signature"
      :signatureImageUrl="signatureImageUrl"
      :isEditable="isEditable"
      @onRewrite="onRewrite"
      @onClose="$listeners['onClose']"
    />
  </div>
</template>

<script>
import FileUsecase from "@/usecases/file.usecase";

// Components
import MySignatureEditor from "@/components/Common/MySignature/Editor.vue";
import MySignatureViewer from "@/components/Common/MySignature/Viewer.vue";

export default {
  name: "CommonMySignature",
  components: {
    MySignatureEditor,
    MySignatureViewer,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    signature: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      signatureImageUrl: "",
      isLoading: true,
    };
  },
  watch: {
    signature: async function () {
      this.isLoading = true;

      await this.fetchSignatureImageUrl();

      this.isLoading = false;
    },
  },
  async mounted () {
    if (this.signature) {
      await this.fetchSignatureImageUrl();
    }

    this.isLoading = false;
  },
  methods: {
    /**
     * [fetchSignatureImageUrl description]
     * @return  {[type]}  [return description]
     */
    async fetchSignatureImageUrl () {
      const { signature } = this;

      if (!signature) {
        return;
      }

      this.signatureImageUrl = await usecase.file.fetchURL(signature);
    },

    /**
     * [onRewrite description]
     * @return  {[type]}  [return description]
     */
    onRewrite () {
      this.signatureImageUrl = "";
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
</style>
